import useDealer from "hooks/useDealer";

// core components
import PageLayout from "layouts/PageLayout";
import EditFooterOptions from "components/EditFooterOptions/EditFooterOptions";

export default function FooterOptions() {
    const dealer = useDealer();

    return (
        <PageLayout showSelectDealer={false}>
            <EditFooterOptions dlid={dealer.id} />
        </PageLayout>
    );
}
